import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';

import {
  renderModal,
  closeModal,
} from '../../shared/components/layouts/OldModal';

import {deleteTradeSupportingDocument} from '../actions';

import TextArea from '../../shared/components/forms/Textarea';
import Confirmation from '../../shared/components/notices/Confirmation';

class TradeSupportingDocumentForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      data: this.props.data,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange = e => {
    let {value, name} = e.target;
    let data = {...this.state.data, [name]: value};

    this.setState({data, errors: {...this.state.errors, [name]: ''}}, () => {
      this.props.updateItem(data, this.props.listID);
    });
  };

  onDeleteConfirmation = () => {
    this.props.onClickModalConfirm();
    this.props.dispatch(
      deleteTradeSupportingDocument(
        this.props.user_id,
        this.props.tradeDocumentType,
        this.props.tradeDocumentID,
        this.props.data.id,
        () => {
          this.props.deleteItem(this.props.data.id);
          closeModal();
        },
      ),
    );
  };

  onDelete = () => {
    this.props.onDeleteDocument();
    renderModal(
      <Confirmation
        onCancel={this.props.onClickModalCancel}
        onClose={this.props.onClickModalClose}
        onConfirm={this.onDeleteConfirmation}>
        Are you sure you want to remove this document?
      </Confirmation>,
    );
  };

  render() {
    let attachment = this.state.data.trade_supporting_attachments[0];

    return (
      <Fragment>
        <li>
          <div className="text _wrapContent">
            <i className="materialIcon --micro">insert_drive_file</i>
            <p className="byline">
              <b className="emphasize">File selected: </b>
              {attachment && attachment.name}
            </p>
          </div>
          <button className="ds-btn --micro _link" onClick={this.onDelete}>
            <i
              className="materialIcon --micro -danger"
              data-testid="remove-file-button">
              close
            </i>
          </button>
        </li>
        <TextArea
          label="Document Description"
          ref="description"
          id="description"
          name="description"
          error={this.state.errors.description}
          value={this.state.data.description || ''}
          data-validation="required"
          onChange={this.onChange}
          onClick={this.props.onClickDescription}
          placeholder="Enter Document Description"
          className="_padding--normal"
        />
      </Fragment>
    );
  }
}

TradeSupportingDocumentForm.defaultProps = {
  onClickModalCancel: () => {},
  onClickModalClose: () => {},
  onClickModalConfirm: () => {},
  onClickDescription: () => {},
  onDeleteDocument: () => {},
};

const mapStateToProps = state => {
  return {
    user_id: state.user.id,
  };
};

export default connect(mapStateToProps)(TradeSupportingDocumentForm);



// WEBPACK FOOTER //
// ./src/features/supporting_documents/containers/Form.js